import { connect } from 'react-redux'
import { IStoreState, IMobilityOptionObject } from '../../types/index'
import {
  getMobilityOptions,
  getMobilityOptionCategories,
  createMobilityOption
} from 'src/state/actions/mobility-options'
import AddMobilityDeviceModal from 'src/components/global-settings/AddMobilityDeviceModal'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    categories: state.mobilityOptionsCategories.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    create: (mobility: IMobilityOptionObject) => {
      return dispatch(createMobilityOption(mobility))
    },
    getMobilityOptions: () => {
      return dispatch(getMobilityOptions())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddMobilityDeviceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddMobilityDeviceModal.ts